import { Action, IEventHandler, ofType } from '@bees-lite-web/core';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionsUrl } from '../../core/actionUrl.shortcut';
import { IAMAbstractService } from '../../services/IAM/IAM.abstract.service';

interface IGetAccessTokenParams {
  state: string;
  code: string;
}

export class ActionsLoginHandler
  implements IEventHandler<IGetAccessTokenParams>
{
  constructor(private IAMService: IAMAbstractService) {}

  handler(
    source: Observable<Action<'action', IGetAccessTokenParams>>
  ): Observable<Action<'action', IGetAccessTokenParams>> {
    return source.pipe(
      ofType((action) => action.url === ActionsUrl.LOGIN),
      concatMap(async (e) => {
        (this.IAMService as any).login();
        return e;
      })
    );
  }
}
